import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { CapacityModelService } from "./../services/CapacityModel-Service";
import { ResponseMsg } from "./../common/response-message";
import { ActivatedRoute, Router } from "@angular/router";
import { ValidateDataService } from "./../services/validate-data.service";
import { QuotaInputData } from "./../models/cm-model";
import { UserData } from '../shared/models/user.model';
import {SohoModalDialogService, SohoBusyIndicatorDirective,
  SohoMessageRef, SohoNotificationService,SohoDatePickerComponent} from "ids-enterprise-ng";
import { DatePipe } from '@angular/common';          


@Component({
  selector: 'app-download-manual-template',
  template: 
  `<div><p> &nbsp;&nbsp; Click on below links to download templates</p> <br>
  <div style="font-size: 1.6rem; padding: 10px;padding-bottom:0px"> <a href="assets/Templates/2026BookingsSemiannualMBOV150Plan.xlsx" download="2026BookingsSemiannualMBOV150Plan.xlsx">2026 Bookings Semiannual MBO V150 Plan</a></div>
  <div style="font-size: 1.6rem; padding: 10px;padding-bottom:0px"> <a href="assets/Templates/2026HardwareRepSalesPlan.xlsx" download="2026HardwareRepSalesPlan.xlsx">2026 Hardware Rep Sales Plan</a></div>
  <div style="font-size: 1.6rem; padding: 10px;padding-bottom:0px"> <a href="assets/Templates/2026NexusSAMPlanv1.xlsx" download="2026NexusSAMPlan.xlsx">2026 Nexus SAM Plan</a></div>
  <div style="font-size: 1.6rem; padding: 10px;padding-bottom:0px"> <a href="assets/Templates/2026PartnerBusinessDevelopmentPlan.xlsx" download="2026PartnerBusinessDevelopmentPlan.xlsx">2026 Partner Business Development Plan</a></div>
  <div style="font-size: 1.6rem; padding: 10px;padding-bottom:0px"> <a href="assets/Templates/2026TSEandRevenuePlanv1.xlsx" download="2026TSEandRevenuePlan.xlsx">2026 TSE and Revenue Plan</a></div>
  <div style="font-size: 1.6rem; padding: 10px;padding-bottom:0px"> <a href="assets/Templates/2026TSERevenueandMBOPlan.xlsx" download="2026TSERevenueandMBOPlan.xlsx">2026 TSE Revenue and MBO Plan</a></div>
  </div>
  `,
  providers: [DatePipe]
})
export class DownloadManualTemplateComponent implements OnInit {
    constructor(private capacityModelService : CapacityModelService,public router: Router) {
      }

  ngOnInit(): void {
  }
}
